export default __webpack_public_path__ + "static/media/pot4.4061c141.svg";